// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Light polish of the access forms (login, password reset/request, account creation) that keeps
 * their original layout: outlined fields like the other forms, more breathing room
 * and clearer buttons. Use it with @include auth-polish.form; at the END of the form
 * stylesheet, so it wins over the older rules. */
/* Page around the forms: slightly narrower column and a more compact logo */
ion-checkbox {
  margin-left: 0;
}

ion-button {
  width: 100%;
}

.iconTab {
  height: 15px;
  font-size: 16px;
}

.centerCol {
  display: flex;
  align-items: center;
}

ion-item.item-has-focus ion-label {
  color: var(--ion-color-secondary);
}
ion-item ion-input {
  border-bottom: thin solid rgba(var(--ion-color-medium-rgb), 0.25);
  --padding-end: 33px;
}
ion-item ion-input.ion-valid.has-focus {
  border-bottom-color: var(--ion-color-primary);
  border-bottom-width: 2px;
}

.item-remember-me {
  margin-top: 9px;
}

.item-auto-access {
  margin-bottom: 9px;
}

.checkbox-in-list,
.checkbox-label {
  margin-top: 0;
  margin-bottom: 0;
}

.item-checkbox {
  --ripple-color: transparent;
  --background-hover: var(--background);
  --min-height: 35px;
}

.button-confirm {
  --box-shadow: none;
  --border-radius: 10px;
  font-size: 17px;
  margin-top: 20px;
}

.button-account {
  --box-shadow: none;
  --background: white;
  color: var(--ion-color-primary);
  border: 1px solid var(--ion-color-primary) !important;
}

.divRole {
  background-color: var(--ion-color-primary);
  color: white;
  width: 100%;
  border-radius: 10px;
  cursor: hand;
  cursor: pointer;
  border: 2px solid var(--ion-color-primary);
}
.divRole ion-icon {
  color: white;
}

.divRoleNotSelected {
  background-color: white;
  border-radius: 10px;
  width: 100%;
  color: var(--ion-color-primary);
  border: 2px solid var(--ion-color-primary);
  cursor: hand;
  cursor: pointer;
}

.gridRole {
  padding: 15px 15px;
}

ion-icon {
  color: var(--ion-color-primary);
}

.roleItem {
  margin-top: 5px;
}

.labelRole {
  margin-left: 5px;
}

.labelDescription {
  font-size: 10px;
  margin-left: 5px;
}

.label-floating-login {
  margin-left: 5px;
  margin-right: 5px;
}

.button-go-back {
  background-color: white;
  border: 2px solid var(--ion-color-primary);
  border-radius: 10px;
  color: var(--ion-color-primary);
  --background: "white";
  font-size: 13px;
}

.titleLbl {
  text-align: justify;
  font-size: 18px;
  font-weight: 600;
}

.descriptionlbl {
  text-align: justify;
}

/* Light polish keeping the original look (kept last so it wins over the rules above) */
/* Fields: outlined and rounded like the other forms, primary ring when focused */
ion-input[fill=outline],
ion-select[fill=outline] {
  --border-radius: 10px;
  --border-color: rgba(var(--ion-color-medium-rgb), 0.4);
  --highlight-color-focused: var(--ion-color-primary);
  --background: var(--ion-background-color, #fff);
  min-height: 56px;
  margin-bottom: 14px;
}

/* Title / description of the forms */
.titleLbl {
  font-size: 20px;
  font-weight: 700;
  text-align: left;
}

.descriptionlbl {
  font-size: 14px;
  line-height: 1.5;
  text-align: left;
  color: var(--ion-color-medium-shade);
}

/* "Forgot password?": on the right, under the password */
ion-item:has(.label-forgot-password) {
  --background: transparent;
  --padding-start: 0;
  --inner-padding-end: 0;
  margin-top: -6px;
  text-align: right;
}

.label-forgot-password {
  font-size: 14px;
  font-weight: 600;
}

/* Primary action */
.button-login {
  height: 50px;
  margin-top: 12px;
  --border-radius: 10px;
  --box-shadow: none;
  font-weight: 600;
  letter-spacing: 0.5px;
}

/* Secondary actions (create account, go back): outlined, same size */
.button-account,
.button-go-back {
  height: 50px;
  margin-top: 10px;
  border: 1px solid rgba(var(--ion-color-primary-rgb), 0.5) !important;
  border-radius: 10px !important;
  --border-radius: 10px;
  font-weight: 600;
  letter-spacing: 0.5px;
  transition: background-color 0.15s ease;
}
.button-account:hover,
.button-go-back:hover {
  background-color: rgba(var(--ion-color-primary-rgb), 0.06) !important;
}`, "",{"version":3,"sources":["webpack://./src/theme/_auth-polish.scss","webpack://./src/components/form-components/form-reset-password/form-reset-password.component.scss"],"names":[],"mappings":"AAAA;;;iDAAA;AAyEA,4EAAA;ACvEA;EACE,cAAA;AAIF;;AADA;EACE,WAAA;AAIF;;AADA;EACE,YAAA;EACA,eAAA;AAIF;;AADA;EACE,aAAA;EACA,mBAAA;AAIF;;AACI;EACE,iCAAA;AAEN;AAEE;EACE,iEAAA;EACA,mBAAA;AAAJ;AAEI;EACE,6CAAA;EACA,wBAAA;AAAN;;AAKA;EACE,eAAA;AAFF;;AAKA;EACE,kBAAA;AAFF;;AAKA;;EAEE,aAAA;EACA,gBAAA;AAFF;;AAKA;EACE,2BAAA;EACA,qCAAA;EACA,kBAAA;AAFF;;AAKA;EACE,kBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;AAFF;;AAKA;EACE,kBAAA;EACA,mBAAA;EACA,+BAAA;EACA,qDAAA;AAFF;;AAKA;EACE,0CAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,0CAAA;AAFF;AAIE;EACE,YAAA;AAFJ;;AAMA;EACE,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,+BAAA;EACA,0CAAA;EACA,YAAA;EACA,eAAA;AAHF;;AAMA;EACE,kBAAA;AAHF;;AAMA;EACE,+BAAA;AAHF;;AAMA;EACE,eAAA;AAHF;;AAMA;EACE,gBAAA;AAHF;;AAMA;EACE,eAAA;EACA,gBAAA;AAHF;;AAMA;EACE,gBAAA;EACA,iBAAA;AAHF;;AAMA;EACE,uBAAA;EACA,0CAAA;EACA,mBAAA;EACA,+BAAA;EACA,qBAAA;EACA,eAAA;AAHF;;AAMA;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;AAHF;;AAMA;EACE,mBAAA;AAHF;;AAMA,uFAAA;ADvIE,iFAAA;AACA;;EAEE,qBAAA;EACA,sDAAA;EACA,mDAAA;EACA,+CAAA;EACA,gBAAA;EACA,mBAAA;ACqIJ;;ADlIE,qCAAA;AACA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;ACqIJ;;ADlIE;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,oCAAA;ACqIJ;;ADlIE,yDAAA;AACA;EACE,yBAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,iBAAA;ACqIJ;;ADlIE;EACE,eAAA;EACA,gBAAA;ACqIJ;;ADlIE,mBAAA;AACA;EACE,YAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;ACqIJ;;ADlIE,qEAAA;AACA;;EAEE,YAAA;EACA,gBAAA;EACA,oEAAA;EACA,8BAAA;EACA,qBAAA;EACA,gBAAA;EACA,qBAAA;EACA,uCAAA;ACqIJ;ADnII;;EACE,qEAAA;ACsIN","sourcesContent":["/* Light polish of the access forms (login, password reset/request, account creation) that keeps\n * their original layout: outlined fields like the other forms, more breathing room\n * and clearer buttons. Use it with @include auth-polish.form; at the END of the form\n * stylesheet, so it wins over the older rules. */\n\n@mixin form {\n  /* Fields: outlined and rounded like the other forms, primary ring when focused */\n  ion-input[fill=\"outline\"],\n  ion-select[fill=\"outline\"] {\n    --border-radius: 10px;\n    --border-color: rgba(var(--ion-color-medium-rgb), 0.4);\n    --highlight-color-focused: var(--ion-color-primary);\n    --background: var(--ion-background-color, #fff);\n    min-height: 56px;\n    margin-bottom: 14px;\n  }\n\n  /* Title / description of the forms */\n  .titleLbl {\n    font-size: 20px;\n    font-weight: 700;\n    text-align: left;\n  }\n\n  .descriptionlbl {\n    font-size: 14px;\n    line-height: 1.5;\n    text-align: left;\n    color: var(--ion-color-medium-shade);\n  }\n\n  /* \"Forgot password?\": on the right, under the password */\n  ion-item:has(.label-forgot-password) {\n    --background: transparent;\n    --padding-start: 0;\n    --inner-padding-end: 0;\n    margin-top: -6px;\n    text-align: right;\n  }\n\n  .label-forgot-password {\n    font-size: 14px;\n    font-weight: 600;\n  }\n\n  /* Primary action */\n  .button-login {\n    height: 50px;\n    margin-top: 12px;\n    --border-radius: 10px;\n    --box-shadow: none;\n    font-weight: 600;\n    letter-spacing: 0.5px;\n  }\n\n  /* Secondary actions (create account, go back): outlined, same size */\n  .button-account,\n  .button-go-back {\n    height: 50px;\n    margin-top: 10px;\n    border: 1px solid rgba(var(--ion-color-primary-rgb), 0.5) !important;\n    border-radius: 10px !important;\n    --border-radius: 10px;\n    font-weight: 600;\n    letter-spacing: 0.5px;\n    transition: background-color 0.15s ease;\n\n    &:hover {\n      background-color: rgba(var(--ion-color-primary-rgb), 0.06) !important;\n    }\n  }\n}\n\n/* Page around the forms: slightly narrower column and a more compact logo */\n@mixin page {\n  .content-login {\n    width: min(100%, 520px);\n  }\n\n  .container-logo-login img {\n    max-height: 180px;\n    margin-block-end: 32px;\n  }\n}\n","@use \"../../../theme/auth-polish\";\n\nion-checkbox {\n  margin-left: 0;\n}\n\nion-button {\n  width: 100%;\n}\n\n.iconTab {\n  height: 15px;\n  font-size: 16px;\n}\n\n.centerCol {\n  display: flex;\n  align-items: center;\n}\n\nion-item {\n  &.item-has-focus {\n    ion-label {\n      color: var(--ion-color-secondary);\n    }\n  }\n\n  ion-input {\n    border-bottom: thin solid rgba(var(--ion-color-medium-rgb), 0.25);\n    --padding-end: 33px;\n\n    &.ion-valid.has-focus {\n      border-bottom-color: var(--ion-color-primary);\n      border-bottom-width: 2px;\n    }\n  }\n}\n\n.item-remember-me {\n  margin-top: 9px;\n}\n\n.item-auto-access {\n  margin-bottom: 9px;\n}\n\n.checkbox-in-list,\n.checkbox-label {\n  margin-top: 0;\n  margin-bottom: 0;\n}\n\n.item-checkbox {\n  --ripple-color: transparent;\n  --background-hover: var(--background);\n  --min-height: 35px;\n}\n\n.button-confirm {\n  --box-shadow: none;\n  --border-radius: 10px;\n  font-size: 17px;\n  margin-top: 20px;\n}\n\n.button-account {\n  --box-shadow: none;\n  --background: white;\n  color: var(--ion-color-primary);\n  border: 1px solid var(--ion-color-primary) !important;\n}\n\n.divRole {\n  background-color: var(--ion-color-primary);\n  color: white;\n  width: 100%;\n  border-radius: 10px;\n  cursor: hand;\n  cursor: pointer;\n  border: 2px solid var(--ion-color-primary);\n\n  ion-icon {\n    color: white;\n  }\n}\n\n.divRoleNotSelected {\n  background-color: white;\n  border-radius: 10px;\n  width: 100%;\n  color: var(--ion-color-primary);\n  border: 2px solid var(--ion-color-primary);\n  cursor: hand;\n  cursor: pointer;\n}\n\n.gridRole {\n  padding: 15px 15px;\n}\n\nion-icon {\n  color: var(--ion-color-primary);\n}\n\n.roleItem {\n  margin-top: 5px;\n}\n\n.labelRole {\n  margin-left: 5px;\n}\n\n.labelDescription {\n  font-size: 10px;\n  margin-left: 5px;\n}\n\n.label-floating-login {\n  margin-left: 5px;\n  margin-right: 5px;\n}\n\n.button-go-back {\n  background-color: white;\n  border: 2px solid var(--ion-color-primary);\n  border-radius: 10px;\n  color: var(--ion-color-primary);\n  --background: \"white\";\n  font-size: 13px;\n}\n\n.titleLbl {\n  text-align: justify;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.descriptionlbl {\n  text-align: justify;\n}\n\n/* Light polish keeping the original look (kept last so it wins over the rules above) */\n@include auth-polish.form;\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
